export default __webpack_public_path__ + "static/media/boi-logo.d513303c.png";